var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.showForm
      ? _c("div", { staticClass: "modal-backdrop fade in" })
      : _vm._e(),
    _vm._v(" "),
    _vm.showForm
      ? _c(
          "div",
          { staticClass: "modal fade in", staticStyle: { display: "block" } },
          [
            _c("div", { staticClass: "modal-dialog" }, [
              _c(
                "div",
                { staticClass: "modal-content" },
                [
                  _c("SubgroupForm", {
                    attrs: { subgroup: _vm.editingSubgroup },
                    on: { save: _vm.handleSave, cancel: _vm.closeForm }
                  })
                ],
                1
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showRules
      ? _c("div", { staticClass: "modal-backdrop fade in" })
      : _vm._e(),
    _vm._v(" "),
    _vm.showRules
      ? _c(
          "div",
          { staticClass: "modal fade in", staticStyle: { display: "block" } },
          [
            _c("div", { staticClass: "modal-dialog modal-lg" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "a",
                    {
                      staticClass: "close",
                      on: { click: _vm.closeRulesManager }
                    },
                    [_vm._v("×")]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "modal-title" }, [
                    _vm._v(
                      "Manage Rules for " + _vm._s(_vm.selectedSubgroup.name)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c("SubgroupRules", {
                      attrs: {
                        subgroup: _vm.selectedSubgroup,
                        "domain-uuid": _vm.domainUuid
                      },
                      on: { close: _vm.closeRulesManager }
                    })
                  ],
                  1
                )
              ])
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "pull-right" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { disabled: !_vm.canManageSubgroups },
            on: { click: _vm.showAddForm }
          },
          [_vm._v("Add Subgroup")]
        )
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("Subgroups")])
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "text-center" }, [
          _c("i", { staticClass: "fa fa-spinner fa-spin fa-2x" })
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.loading && _vm.subgroups.length === 0
      ? _c("div", [_c("p", [_vm._v("No subgroups have been created yet.")])])
      : _vm._e(),
    _vm._v(" "),
    _vm.errorMessage
      ? _c("div", { staticClass: "alert alert-warning" }, [
          _vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.loading && _vm.subgroups.length > 0
      ? _c("div", [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filterText,
                  expression: "filterText"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", placeholder: "Filter by name..." },
              domProps: { value: _vm.filterText },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.filterText = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("table", { staticClass: "table table-striped" }, [
            _c("thead", [
              _c("tr", [
                _c(
                  "th",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: { click: _vm.sortByName }
                  },
                  [
                    _vm._v("\n            Name\n            "),
                    _c("i", {
                      staticClass: "fa",
                      class: {
                        "fa-sort-asc":
                          _vm.sortBy === "name" && _vm.sortDir === "asc",
                        "fa-sort-desc":
                          _vm.sortBy === "name" && _vm.sortDir === "desc"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: { click: _vm.sortByType }
                  },
                  [
                    _vm._v("\n            Type\n            "),
                    _c("i", {
                      staticClass: "fa",
                      class: {
                        "fa-sort-asc":
                          _vm.sortBy === "type" && _vm.sortDir === "asc",
                        "fa-sort-desc":
                          _vm.sortBy === "type" && _vm.sortDir === "desc"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: { click: _vm.sortByEnabledRules }
                  },
                  [
                    _vm._v("\n            Enabled Rules\n            "),
                    _c("i", {
                      staticClass: "fa",
                      class: {
                        "fa-sort-asc":
                          _vm.sortBy === "enabled_rules_count" &&
                          _vm.sortDir === "asc",
                        "fa-sort-desc":
                          _vm.sortBy === "enabled_rules_count" &&
                          _vm.sortDir === "desc"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("th", [_vm._v("Actions")])
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.filteredSubgroups, function(subgroup) {
                return _c("tr", { key: subgroup.uuid }, [
                  _c("td", [
                    _vm._v(_vm._s(subgroup.name) + " "),
                    subgroup.user_count
                      ? _c("span", { staticClass: "small" }, [
                          _vm._v("(" + _vm._s(subgroup.user_count) + " users)")
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(subgroup.type || "-"))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(subgroup.enabled_rules_count || 0))]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-xs btn-default",
                        attrs: { disabled: !_vm.canManageSubgroups },
                        on: {
                          click: function($event) {
                            return _vm.showEditForm(subgroup)
                          }
                        }
                      },
                      [_vm._v("Edit")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-xs btn-info",
                        attrs: { disabled: !_vm.canManageSubgroups },
                        on: {
                          click: function($event) {
                            return _vm.showRulesManager(subgroup)
                          }
                        }
                      },
                      [_vm._v("Manage Rules")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-xs btn-danger",
                        attrs: { disabled: !_vm.canManageSubgroups },
                        on: {
                          click: function($event) {
                            return _vm.showDeleteConfirm(subgroup)
                          }
                        }
                      },
                      [_vm._v("Delete")]
                    )
                  ])
                ])
              }),
              0
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }